export default __webpack_public_path__ + "static/media/IMG_5574.e957c3d1.jpg";